<div class="kb-list-container">
  <ngx-spinner name="kb-list-spinner" bdColor="rgba(0,0,0,0.3)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="color: white">Loading...</p>
  </ngx-spinner>

  <ng-container *ngIf="!showCategoryManager">
    <!-- Header -->
    <div class="row align-items-center mb-3">
      <div class="col">
        <h3 class="mb-0">Knowledge Base</h3>
      </div>
      <div class="col-auto d-flex align-items-center" *ngIf="role === 'admin'">
        <button nbButton status="primary" size="small" (click)="navigateToNew()">
          <nb-icon icon="plus-outline" pack="eva"></nb-icon> New Article
        </button>
        <button nbButton status="basic" size="small" (click)="openCategoryManager()" class="ms-2" nbTooltip="Manage Categories">
          <nb-icon icon="settings-2-outline" pack="eva"></nb-icon>
        </button>
      </div>
    </div>

    <!-- Filters -->
    <div class="row mb-3 g-2">
      <div class="col-sm-4">
        <nb-select placeholder="All Categories" [(ngModel)]="categoryFilter" (selectedChange)="onFilterChange()" fullWidth>
          <nb-option value="">All Categories</nb-option>
          <nb-option *ngFor="let cat of categories" [value]="cat.slug">{{ cat.name }}</nb-option>
        </nb-select>
      </div>
      <div class="col-sm-6">
        <input nbInput fullWidth placeholder="Search articles..." [(ngModel)]="searchQuery" (ngModelChange)="onSearchChange()" />
      </div>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!loading && articles.length === 0">
      <nb-icon icon="book-open-outline" class="empty-icon" pack="eva"></nb-icon>
      <p class="text-muted">No articles found.</p>
    </div>

    <!-- Articles Grid -->
    <div class="articles-grid" *ngIf="articles.length > 0">
      <nb-card *ngFor="let article of articles | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage, totalItems: totalCount }" class="article-card" (click)="navigate(article._id)">
        <nb-card-body>
          <h4 class="article-title">{{ article.title }}</h4>
          <span *ngIf="article.category" class="badge bg-info text-white mb-2 me-1">{{ article.category }}</span>
          <ng-container *ngIf="article.audience && article.audience.length > 0">
            <span *ngFor="let r of article.audience" class="badge bg-warning text-dark me-1">{{ r }}</span>
          </ng-container>
          <span *ngIf="!article.audience || article.audience.length === 0" class="badge bg-success text-white me-1">Public</span>
          <p class="article-excerpt text-muted">{{ article.excerpt || getExcerpt(article.content) }}</p>
          <div class="article-meta">
            <small class="text-muted" *ngIf="article.viewCount != null">
              <nb-icon icon="eye-outline" class="meta-icon" pack="eva"></nb-icon> {{ article.viewCount }} views
            </small>
          </div>
          <button nbButton status="primary" size="tiny" class="mt-2" (click)="$event.stopPropagation(); navigate(article._id)">
            Read Article
          </button>
        </nb-card-body>
      </nb-card>
    </div>

    <!-- Pagination -->
    <div class="pagination-row mt-3" *ngIf="totalCount > itemsPerPage">
      <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true"></pagination-controls>
    </div>
  </ng-container>

  <app-kb-category-manager *ngIf="showCategoryManager" (back)="onCategoryManagerBack()"></app-kb-category-manager>
</div>
